import { AbsProduct } from '@/creditflowresearch/domain/Product';
import type { QuerySanitizer } from './types';
import { regionsValidator } from './sanitize';

const absOnlyProductsValidator: QuerySanitizer = () => AbsProduct.ABBREVIATION;

export const absBondScreenerValidators: Record<string, QuerySanitizer> = {
  products: absOnlyProductsValidator,
  regions: regionsValidator,
};
